module.exports = __webpack_public_path__ + "media/assets/images/logos/AWS-select-consulting-partner-amazon-connect-cad06c8f8cd6ce3e5a2a30804d2f0152.jpg";